<!-- 提取明细 -->
<template>
  <div class="container">
    <div class="mainFooter">
      <div class="left">查询关键词：</div>
      <el-input
        size="small"
        style="width: 2rem; margin-right: 0.1rem"
        placeholder="请输入提取订单编号"
      ></el-input>
      <el-date-picker
        size="small"
        style="margin-right: 0.1rem"
        type="daterange"
        range-separator="至"
        start-placeholder="操作开始日期"
        end-placeholder="操作结束日期"
      >
      </el-date-picker>
      <el-select size="small" v-model="value" placeholder="提取状态">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <div style="display: flex; align-items: center; margin-left: auto">
        <el-button style="color: #ed7046" size="small">重置</el-button>
        <el-button style="color: #ed7046" size="small">搜索</el-button>
      </div>
    </div>
    <p class="p3">符合条件共：提现金额（ <span>0¥</span> ）</p>
    <el-table
      border
      header-align="center"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column align="center" prop="orderNumber" label="提取订单号">
      </el-table-column>
      <el-table-column align="center" prop="createName" label="提取申请人">
      </el-table-column>
      <el-table-column align="center" label="申请时间">
        <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatHms }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="收款账户">
        <template slot-scope="scope">
            {{ payMode[scope.row.source] }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="address" label="提取状态">
      </el-table-column>
      <el-table-column align="center" label="提取金额">
        <template slot-scope="scope">
            {{ scope.row.price + '¥' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props:{
    tableData:{
      type:Array,
      default:[]
    },
  },
  data() {
    return {
      value:'',
      payMode:{
        0:'微信 ',
        1:'支付宝',
        2:'余额',
        3:'线下转账'
      },
      options: [
        {
          value: "1",
          label: "已申请待开发票",
        },
        {
          value: "2",
          label: "已申请平台已收到发票",
        },
        {
          value: "3",
          label: "已申请平台待支付",
        },
        {
          value: "4",
          label: "平台已支付（实际已提取）",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.container {
  .mainFooter {
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;
    background-color: #f3f3f3;
    padding: 0.15rem;
    .left {
      font-size: 0.12rem;
    }
  }
  .p3 {
    margin-bottom: 0.24rem;
    span {
      color: #dc7039;
      font-weight: bold;
    }
  }
}
</style>
